"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STATE_KEY_NAME = exports.DEFAULT_LANGUAGE = exports.DEFAULT_CULTURE = void 0;

/**
 * @description
 * Default culture that will be used as a fallback.
 *
 * @type {string}
 */
var DEFAULT_CULTURE = 'en-150';
/**
 * @description
 * Default language that will be used as a fallback.
 *
 * @type {string}
 */

exports.DEFAULT_CULTURE = DEFAULT_CULTURE;
var DEFAULT_LANGUAGE = 'en';
/**
 * @description
 * Defines a property name that will be used in the Redux state.
 *
 * @type {string}
 */

exports.DEFAULT_LANGUAGE = DEFAULT_LANGUAGE;
var STATE_KEY_NAME = 'locale';
exports.STATE_KEY_NAME = STATE_KEY_NAME;
//# sourceMappingURL=constants.js.map